var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5543_30471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5939 7.19494C12.2054 7.19494 12.7918 6.95204 13.2242 6.51967C13.6565 6.08731 13.8994 5.50089 13.8994 4.88944C13.8994 4.27798 13.6565 3.69156 13.2242 3.2592C12.7918 2.82683 12.2054 2.58393 11.5939 2.58393M13.8994 11.0374C15.2474 11.3333 16.2049 12.0818 16.2049 12.9587C16.2049 13.7503 15.4257 14.4365 14.2837 14.7801M10.0569 4.88944C10.0569 6.58716 8.68063 7.96344 6.9829 7.96344C5.28518 7.96344 3.9089 6.58716 3.9089 4.88944C3.9089 3.19171 5.28518 1.81543 6.9829 1.81543C8.68063 1.81543 10.0569 3.19171 10.0569 4.88944ZM12.3624 13.343C12.3624 15.0407 9.95393 16.417 6.9829 16.417C4.01188 16.417 1.60339 15.0407 1.60339 13.343C1.60339 11.6452 4.01188 10.2689 6.9829 10.2689C9.95393 10.2689 12.3624 11.6452 12.3624 13.343Z",
    stroke: "currentColor",
    strokeWidth: 1.26803,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5543_30471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.444,
    height: 18.444,
    fill: "currentColor",
    transform: "translate(0.0664062 0.27832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.3929a140eb7ffe2cc804533350b1e8de.svg";
export { ForwardRef as ReactComponent };